var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_84",
    "data-name": "Grupo 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.993,
    height: 22.047,
    viewBox: "0 0 9.993 22.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_22",
    "data-name": "Ret\\xE2ngulo 22",
    width: 9.993,
    height: 22.047,
    fill: "#35bde8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_83",
    "data-name": "Grupo 83",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M3.12,14.383v5.672c0,.082,0,.164,0,.245.013.5.3.826.72.816a.719.719,0,0,0,.687-.813q.006-3.066,0-6.132c0-.505.138-.714.467-.712s.458.206.458.72q0,2.989,0,5.979c0,.621.244.954.7.959s.71-.333.711-.946c0-.419,0-.838,0-1.257.006-.342.179-.537.457-.539s.458.194.464.534c.008.48.006.961,0,1.441a1.588,1.588,0,0,1-.91,1.515,1.544,1.544,0,0,1-1.75-.2c-.118-.093-.176-.071-.28.009a1.55,1.55,0,0,1-1.752.188,1.592,1.592,0,0,1-.9-1.523c0-1.584-.007-3.168,0-4.752,0-.265-.043-.315-.317-.248a1.525,1.525,0,0,1-1.871-1.47C-.012,12.843.006,11.82,0,10.8,0,9.909.02,9.02,0,8.131A3.136,3.136,0,0,1,2,5.012c.211-.1.234-.159.127-.368A3.2,3.2,0,1,1,8.178,3.2a2.893,2.893,0,0,1-.337,1.416c-.112.206-.1.29.129.393A3.2,3.2,0,0,1,9.807,6.871a3.5,3.5,0,0,1,.176,1.206c0,1.86-.029,3.721.009,5.58a1.582,1.582,0,0,1-2.016,1.651c-.167-.056-.188.024-.187.161,0,.491.008.981,0,1.472a.463.463,0,0,1-.489.506.425.425,0,0,1-.408-.354,1.9,1.9,0,0,1-.023-.366q0-4.078,0-8.156c0-.5.146-.722.463-.72s.462.227.462.723q0,2.5,0,5a2.061,2.061,0,0,0,.025.4.627.627,0,0,0,1.227-.03,2.387,2.387,0,0,0,.015-.367q0-2.668,0-5.335A2.328,2.328,0,0,0,7.3,5.718c-.143-.053-.291-.095-.435-.145-.416-.143-.52-.473-.235-.805a2.389,2.389,0,0,0,.581-1.162,2.276,2.276,0,1,0-4,1.04c.045.055.1.106.14.162a.454.454,0,0,1-.22.757,6.261,6.261,0,0,0-.992.4A2.165,2.165,0,0,0,.928,7.977c0,1.911,0,3.822,0,5.733,0,.494.305.794.725.734.342-.049.538-.307.539-.738,0-1.339,0-2.678,0-4.016,0-.429-.005-.859,0-1.288.006-.35.2-.563.478-.553s.441.211.442.554q0,2.989,0,5.979",
    transform: "translate(0 0)",
    fill: "#35bde8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildren);
export default __webpack_public_path__ + "static/media/children.87dd909999c56e76e573116c4d4fe1bf.svg";
export { ForwardRef as ReactComponent };